<template>
    <div id="materials" class="ui segment">
        <CRUDTemplate
            :columns="columns"
            :header_buttons="header_buttons"
            :module_scope="module_scope"
            :module_name="module_name"
            :paginator_channel_name="paginator_channel_name"
            :fetch_index_items_url="fetch_index_items_url"
            :edit_index_item_url="edit_index_item_url"
            :update_index_item_url="update_index_item_url"
            :authentication_token="authentication_token"
            :index_item_name="index_item_name"
            :api_response_corresponding_name_of_index_items="api_response_corresponding_name_of_index_items"
            :api_response_corresponding_name_of_index_item="api_response_corresponding_name_of_index_item"
            :blank_value_text="blank_value_text"
        >
    </CRUDTemplate>
    </div>
</template>

<script>
import CRUDTemplate from "@toolbox/crud_templates/index.vue"
export default {
    name: "MaterialsIndex",
    data() {
        return {
            columns: [
                {
                    filter: {
                        type: null,
                        // human_name: "物料名稱",
                        human_name: this.$t('models.attributes.materials.name'),
                        attribute_name: "name",
                    },
                    item: {
                        type: "text",
                        attribute_name: "name",
                    }
                },
                {
                    filter: {
                        type: null,
                        // human_name: "物料英文",
                        human_name: this.$t('models.attributes.materials.en_name'),
                        attribute_name: "en_name",
                    },
                    item: {
                        type: "text",
                        attribute_name: "en_name",
                    }
                },
                {
                    filter: {
                        type: null,
                        // human_name: "運單階層",
                        human_name: this.$t('models.attributes.materials.core_waybill_level'),
                        attribute_name: "core_waybill_level",
                    },
                    item: {
                        type: "text",
                        attribute_name: "core_waybill_level",
                    }
                },
                {
                    filter: {
                        type: null,
                        // human_name: "識別名稱",
                        human_name: this.$t('models.attributes.materials.class_name'),
                        attribute_name: "class_name",
                    },
                    item: {
                        type: "text",
                        attribute_name: "class_name",
                    }
                },
                {
                    filter: {
                        type: null,
                        // human_name: "標籤種類",
                        human_name: this.$t('models.attributes.materials.label_type'),
                        attribute_name: "label_type",
                    },
                    item: {
                        type: "text",
                        attribute_name: "label_type",
                    }
                    // item: {
                    //     type: "selection",
                    //     attribute_name: "label_type",
                    //     options: [
                    //         {
                    //             label_type: "Label::ByExpress",
                    //             human_name: "博宇專用標",
                    //         },
                    //     ],
                    //     option_attribute_name: "label_type",
                    //     option_human_name: "human_name",
                    // }
                },
            ],
            header_buttons: [
                {
                    is: "router-link",
                    class: "ui basic positive button",
                    content: "<i class='plus icon'></i>" + this.$t('ui.page_titles.new_material'),
                    to: {name: 'new_material'},
                },
            ],
            module_scope: "provider",
            module_name: "materials_module",
            paginator_channel_name: "materials_index",
            fetch_index_items_url: {
                type: "http",
                url: this.$store.state.provider.routes.api_v1_provider_materials,
                params: [],
            },
            edit_index_item_url: {
                type: "vue",
                url: "edit_material",
                params: [{
                    key_name: "material_identity",
                    attribute_name: "identity",
                    source: "index_item",
                }],
            },
            delete_index_item_url: {
                type: "http",
                url: this.$store.state.provider.routes.api_v1_provider_material_delete,
                params: [{
                    key_name: "material_identity",
                    attribute_name: "identity",
                    source: "index_item",
                }],
            },
            update_index_item_url: {},
            authentication_token: localStorage.getItem("authentication_token"),
            index_item_name: this.$t('models.materials'),
            api_response_corresponding_name_of_index_items: "materials",
            api_response_corresponding_name_of_index_item: "material",
            blank_value_text: "<span style='color: red;'>-</span>"
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
        CRUDTemplate,
    }
}
</script>
